import { Box } from '@factorialco/deprecated-design-system'
import { DetailsItemsList } from '@factorialco/f0-react/dist/experimental'
import { MaterializedFormSimpleFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { Form } from 'modules/forms/lib/Form'
import { formatDateToString } from 'modules/forms/lib/utils/dates'

interface SidebarFormProps {
  form: Form
  materializedForms: MaterializedFormSimpleFragment[] | undefined
}

const SidebarPreview = ({ form, materializedForms }: SidebarFormProps) => {
  const {
    access: { locale },
  } = useCurrentSession()
  return (
    <Box padding="s16">
      <DetailsItemsList
        details={[
          {
            content: {
              avatarUrl: buildUrl(form.authorAvatarUrl),
              firstName: form.authorFullName ?? '',
              lastName: '',
              type: 'person',
            },
            title: i18n.t('forms.sidebar.author'),
          },
          {
            content: {
              customColor: form.anonymous ? '#07A2AD' : '#F59E0B',
              text: form.anonymous
                ? i18n.t('forms.sidebar.anonymous_answers')
                : i18n.t('forms.sidebar.responses_not_anonymous'),
              type: 'dot-tag',
            },
            title: i18n.t('forms.sidebar.privacy_settings'),
          },
          ...(materializedForms?.length && materializedForms.length > 0
            ? [
                {
                  content: materializedForms.map((materializedForm) => ({
                    name: String(materializedForm.resourceName),
                    type: 'team' as const,
                  })),
                  title: i18n.t('forms.sidebar.groups'),
                },
              ]
            : []),
          {
            content: {
              text: formatDateToString(form?.createdAt ?? '', locale),
              type: 'item',
            },
            title: i18n.t('forms.sidebar.creation_date'),
          },
        ]}
        title={i18n.t('forms.sidebar.form_settings')}
      />
    </Box>
  )
}

export default SidebarPreview
